<template>
  <v-dialog v-model="guide" persistent width="600">
    <v-card>
      <v-card-title class="text-center">
        <h4>
          برای استفاده بهتر از سامانه میتوانید از کلیدهای زیر استفاده کنید
        </h4>
      </v-card-title>
      <v-card-text>
        <!-- <h5>عمومی</h5>
         داشبورد -->
        <h5 class="mt-3">انبارداری</h5>
        <v-btn elevation="6" outlined small>s</v-btn> جستجوی پیشرفته <br />
        <v-btn elevation="6" outlined small>n</v-btn> ثبت محصول جدید
      </v-card-text>
      <v-card-subtitle>
        <hr />

        <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
      </v-card-subtitle>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      guide: true,
    };
  },
};
</script>
